import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
export const MeasuresCommentsPDF = ({
  measure
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width12point5
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, measure.comments && `${measure.comments}`));